const axios = require('axios');

// TODO сделать селектор общего назначения

/**
* Добавляет обработчик клика вне указанного элемента.
* @param {string|jQuery} elementSelector - Селектор или jQuery-элемент.
* @param {Function} callback - Функция, которая выполнится при клике вне элемента.
*/
function onClickOutside(elementSelector, callback) {

    $(document).on('click', function (event) {
        const $element = $(elementSelector);

        // Проверяем, был ли клик вне элемента
        if (!$element.is(event.target) && $element.has(event.target).length === 0) {
            callback(event);
        }
    });
}



$(document).on('click', '.select-city__label', function () {
    const root = $(this).closest('.select-city')
    root.toggleClass('--open')
});

onClickOutside('.select-city', function (event) {
    $('.select-city').removeClass('--open');
})

function initCitySelector() {
    console.log('Selector Inited')

    async function fetchCityList(search = '', country = 'RU') {

        const response = await axios.get('/city/search', {
            params: {
                page: 1,
                search: search,
                country: country
            }
        });
        const cityList = response.data?.results?.data || []



        return cityList.map((city) => ({
            city_id: city.id,
            name: city.name?.ru || city.name?.en,
            region: city.region?.name.ru || city.region?.name.en
        }))
    }

    function renderCityList(arrCity, $container) {
        if ($container && $container.length !== 0) {
            $container.html('')
            arrCity.forEach(element => {
                $container.append(
                    `<div class="city-item" data-id="${element.city_id}" data-name="${element.name}" data-region="${element.region || ""}">
                        <div class="city-item__name">
                            ${element.name}
                        </div>
                        <div class="city-item__region" >${element.region ? element.region : ""}</div>
                </div>`
                )
            });
        };
    }

    $('.js-load-city-input').each(async (k, item) => {
        const $country = $(item).data('country')
        const $divCityList = $(item).closest('.select-city').find('.select-city__list')
        const cityList = await fetchCityList('', $country)
        renderCityList(cityList, $divCityList)
    })
    // console.log(.closest('.select-city__content'));

    fetchCityList()
        .then(renderCityList)

    $('.select-city__input').find('input').on('input', async function () {
        const $this = $(this)
        const search = $this.val();

        if (search.length < 2) {
            return;
        }

        const $divCityList = $this.closest('.select-city').find('.select-city__list')

        fetchCityList(search, $this.data('country'))
            .then((cityList) => renderCityList(cityList, $divCityList))

    })

    $('.select-city').on('click', '.city-item', function (event) {
        const cityName = $(this).data('name')
        const cityId = $(this).data('id')
        const regionName = $(this).data('region')

        const $root = $(event.delegateTarget)

        const $select = $root.find('.select-city__form-input')
        const $labelText = $root.find('.select-city__label-text')
        const $regionText = $root.find('.select-city__region-text')

        $select.val(cityId).trigger('input')
        $labelText.text(cityName)
        $regionText.text(regionName)


        $root.removeClass('--open')
    })
}

initCitySelector();
window.initCitySelector = initCitySelector




function initSelector() {
    $(document).on('click', '.u-selector__label', function () {
        const $root = $(this).closest('.u-selector')
        $root.toggleClass('--open')
    })

    $(document).on('click', '.u-selector__content-item', function () {
        const $root = $(this).closest('.u-selector')
        const $input = $root.find('input')

        const value = $(this).data('value')
        const label = $(this).data('label')

        $input.val(value).trigger('input')
        $root.find('.u-selector__label-text').text(label)

        $root.removeClass('--open')
    })

    onClickOutside('.u-selector', function (event) {
        $('.u-selector').removeClass('--open');
    })
}


initSelector();
window.initSelector = initSelector